import { render, staticRenderFns } from "./KimiChat.vue?vue&type=template&id=57b71f9d&scoped=true"
import script from "./KimiChat.vue?vue&type=script&lang=js"
export * from "./KimiChat.vue?vue&type=script&lang=js"
import style0 from "./KimiChat.vue?vue&type=style&index=0&id=57b71f9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b71f9d",
  null
  
)

export default component.exports